export default {
  getList: '/v3/mapping/bd/train/client/core/taskList'
}
